import { useI18n } from "../i18n/I18nContext";
import { useSiteContent } from "../context/SiteContentContext";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";

export default function Contact() {
  const { lang } = useI18n();
  const { content } = useSiteContent();
  const c = (key) => content[key]?.[lang] || content[key]?.en || "";
  const label = lang === "fi" ? "Yhteystiedot" : lang === "sv" ? "Kontakt" : "Contact";

  return (
    <main className="max-w-[820px] mx-auto px-6 md:px-12 pt-16 pb-24" data-testid="contact-page">
      <div className="label-caps text-muted-foreground mb-4">{label}</div>
      <h1 className="font-hand text-5xl md:text-6xl mb-10">
        {lang === "fi" ? "Ota reilusti yhteyttä." : lang === "sv" ? "Hör gärna av dig." : "Get in touch."}
      </h1>

      <div className="space-y-6 mb-14 text-base">
        <ContactRow icon={<Mail strokeWidth={1.5} className="w-5 h-5" />} label={c("footer_email")} href={`mailto:${c("footer_email")}`} />
        <ContactRow icon={<Phone strokeWidth={1.5} className="w-5 h-5" />} label={c("footer_phone")} href={`tel:${(c("footer_phone")||"").replace(/\s/g, "")}`} />
        <ContactRow icon={<MapPin strokeWidth={1.5} className="w-5 h-5" />} label={c("business_address")} />
        <ContactRow
          icon={<Instagram strokeWidth={1.5} className="w-5 h-5" />}
          label="@pikkurumiluksia"
          href="https://instagram.com/pikkurumiluksia"
        />
      </div>

      <div className="border-t border-border pt-8 text-sm text-muted-foreground space-y-1">
        <div className="font-medium text-foreground">{c("business_name")}</div>
        <div>{c("business_address")}</div>
        <div>Y-tunnus: {c("business_id")}</div>
        <div>{c("business_vat_note")}</div>
      </div>
    </main>
  );
}

function ContactRow({ icon, label, href }) {
  const inner = (
    <span className="inline-flex items-center gap-4 group">
      <span className="text-[hsl(var(--primary))]">{icon}</span>
      <span className={href ? "link-underline" : ""}>{label}</span>
    </span>
  );
  return href ? (
    <a href={href} className="block hover:text-[hsl(var(--primary))] transition-colors" target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
      {inner}
    </a>
  ) : (
    <div>{inner}</div>
  );
}
